<script setup>
/**
 * FormControlModulestructureSelectType
 * Composition-based wrapper around the standard select dropdown form control.
 * Contextually exposes internal picklist attributes when an entity type matches 'select',
 * automatically dropping its layout visibility otherwise.
 */
import { onMounted, getCurrentInstance } from 'vue';
import FormControlTypeSelect from '../form-control-type/FormControlTypeSelect.vue';

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Lifecycle ---

onMounted(() => {
    if (!props.field || !props.currentData) return;

    if (props.currentData.type === 'select') {
        // TODO - I don't think this ever does anything.
        store.dispatch(`${props.formId}/setDefaultValue`, {
            name: props.field.name,
            value: ''
        });
    } else {
        // Hide the configuration selector if the schema target isn't a select menu dropdown
        props.field.hidden = true;
    }

    // TODO - In nicks-business this field was varChar, so the default value should be "", but it was set to 0.
    // The field should be upgraded to a number field and the default value set back to 0.
});
</script>

<template>
    <FormControlTypeSelect
        v-if="!field.hidden"
        v-bind="$props"
        v-on="$listeners"
    />
</template>

<style scoped>
/* Presentation and operational properties inherit natively from the underlying type */
</style>